//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

export default {
  name: "HorizontalLinesChart",
  props: {
    id: String,
    chartWidth: Number,
    chartHeight: Number,
    mainColor: String,
    secondaryColor: String,
    mainGraphKey: Number,
    secondaryGraphKey: Number,
    retailer: String,
    data: Object,
    margin: Object,
    lineValueMarginTop: {
      type: Number,
      default: 0,
    },
    lineValueMarginBottom: {
      type: Number,
      default: 0,
    },
  },
  mounted: function () {
    this.renderChart();
  },
  computed: {
    mainData: function () {
      return this.data.mainData;
    },
    secondaryData: function () {
      return this.data.secondaryData;
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartWidth: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartHeight: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
  },
  methods: {
    // FIXME
    // Make the chart responsive somehow.
    // Delete the casts.
    renderChart: function () {
      d3.selectAll(`#${this.id} > *`).remove();
      var width = Number(this.chartWidth);
      var height = Number(this.chartHeight);

      var margin = {
        top: Number(this.margin.top),
        right: Number(this.margin.right),
        bottom: Number(this.margin.bottom),
        left: Number(this.margin.left),
      };

      var horizontalLineGraph = d3
        .select("#horizontalLineGraph")
        .append("div")
        .attr("class", "tool-tip");

      var x = d3
        .scaleBand()
        .domain(
          // d3.range(
          //   // d3.max([
          //   //   this.mainData.length,
          //   //   this.secondaryData ? this.secondaryData.length : 0,
          //   // ])
          //   d3.extent(
          //     this.mainData, d => d.label
          //   )
          // )

          this.mainData.map((d) => d.label)
        )
        .range([margin.left, width - margin.right])
        .paddingInner(0)
        .paddingOuter(0);

      // FIXME
      // Get the values from both data types when needed.
      var y = d3
        .scaleLinear()
        .domain([
          0,
          d3.max(
            this.mainData.concat(this.secondaryData ? this.secondaryData : []),
            (d) => d.value
          ) * 1.1,
        ])
        .nice()
        .range([height - margin.bottom, margin.top]);

      // var per = d3
      //   .scaleLinear()
      //   .domain([
      //     d3.min(this.lineData, (d) => d[1] - this.lineValueMarginBottom),
      //     d3.max(this.lineData, (d) => d[1] + this.lineValueMarginTop),
      //   ])
      //   .nice()
      //   .range([height - margin.bottom, margin.top]);

      var xAxis = (g) =>
        g
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .call(
            d3
              .axisBottom(x)
              .tickValues(this.mainData.map((d) => d.label))
              .tickSizeOuter(0)
          )
          .call((g) =>
            g
              .append("text")
              .attr("transform", "rotate(-90)")
              .attr("x", width - margin.right)
              .attr("y", 0)
              .attr("fill", "currentColor")
              .attr("text-anchor", "start")
          );

      var yAxis = (g) =>
        g
          .attr("transform", `translate(${margin.left},0)`)
          .call(d3.axisLeft(y).ticks(10, ""))
          .call((g) =>
            g
              .append("text")
              .attr("x", 0)
              .attr("y", 10)
              .attr("fill", "currentColor")
              .attr("text-anchor", "start")
          );

      var yGrid = d3
        .axisLeft(y)
        .ticks(10)
        .tickSize(-this.chartWidth)
        .tickFormat("");

      // var perAxis = (g) =>
      //   g
      //     .attr("transform", `translate(${width - margin.right},0)`)
      //     .call(
      //       d3.axisRight(per).tickFormat(function (d) {
      //         return parseInt(d, 10) + "%";
      //       })
      //     )
      //     .call((g) =>
      //       g
      //         .append("text")
      //         .attr("x", 0)
      //         .attr("y", 10)
      //         .attr("fill", "currentColor")
      //         .attr("text-anchor", "start")
      //     );

      var svg = d3
        .select(this.$refs.linesGraphChart)
        .attr("width", width)
        .attr("height", height);

      svg.append("g").attr("class", "grid").call(yGrid);

      if (this.mainData) {
        var line = d3
          .line()
          // .curve(d3.curveBasis)
          // .defined((d) => (d[1]))
          .x((d) => x(d.label) + x.bandwidth() / 2)
          .y((d) => y(d.value));

        svg
          .append("path")
          .datum(this.mainData)
          .attr("fill", "none")
          .attr("stroke", this.mainColor)
          .attr("stroke-width", 2)
          .style("stroke", "7, 10")
          .attr("stroke-linejoin", "round")
          .attr("d", line);

        svg
          .selectAll("myCircles")
          .data(this.mainData)
          .enter()
          .append("circle")
          .attr("fill", this.mainColor)
          .attr("stroke", "none")
          .attr("cx", (d) => x(d.label) + x.bandwidth() / 2)
          .attr("cy", (d) => y(d.value))
          .attr("r", 5);
      }

      if (this.secondaryData) {
        var secondaryLine = d3
          .line()
          // .curve(d3.curveBasis)
          // .defined((d) => (d[1]))
          .x((d) => x(d.label) + x.bandwidth() / 2)
          .y((d) => y(d.value));

        svg
          .append("path")
          .datum(this.secondaryData)
          .attr("fill", "none")
          .attr("stroke", this.secondaryColor)
          .attr("stroke-width", 2)
          .style("stroke", "7, 10")
          .attr("stroke-linejoin", "round")
          .attr("d", secondaryLine);

        svg
          .selectAll("myCircles")
          .data(this.secondaryData)
          .enter()
          .append("circle")
          .attr("fill", this.secondaryColor)
          .attr("stroke", "none")
          .attr("cx", (d) => x(d.label) + x.bandwidth() / 2)
          .attr("cy", (d) => y(d.value))
          .attr("r", 5);
      }

      svg.append("g").call(xAxis);

      svg.append("g").call(yAxis);

      // svg.append("g").call(perAxis);

      //Graph Keys
      svg
        .append("circle")
        .attr("cx", 40)
        .attr("cy", 9)
        .attr("r", 6)
        .style("fill", this.mainColor);
      svg
        .append("text")
        .attr("class", "graph-key")
        .attr("x", 55)
        .attr("y", 10)
        .text(this.mainGraphKey)
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle");
      svg
        .append("circle")
        .attr("cx", 110)
        .attr("cy", 9)
        .attr("r", 6)
        .style("fill", this.secondaryColor);
      svg
        .append("text")
        .attr("class", "graph-key")
        .attr("x", 125)
        .attr("y", 10)
        .text(this.secondaryGraphKey)
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle");

      svg
        .selectAll("circle")
        .on("mousemove", function (e, data) {
          horizontalLineGraph.style("left", e.clientX + 10 + "px");
          horizontalLineGraph.style("top", e.clientY - 20 + "px");
          horizontalLineGraph.style("opacity", "1");
          horizontalLineGraph.html(
            "" +
            "<div>" +
            "<div>Período: " +
            data.label +
            "</div>" +
            "<div>Valor: " +
            d3.format(".3")(data.value) + " %" +
            "</div>" +
            "</div>" +
            ""
          );
        })
        .on("mouseout", function () {
          horizontalLineGraph.style("opacity", "0");
        });
    },
  },
};
